export function getReportLastDay(year, zeroBasedMonth) {
  const today = new Date();
  const reportYear = Number(year);
  const reportMonth = Number(zeroBasedMonth);

  if (reportYear === today.getFullYear() && reportMonth === today.getMonth()) {
    return Math.max(today.getDate() - 1, 0);
  }

  return new Date(reportYear, reportMonth + 1, 0).getDate();
}

export function getReportMonthTimestamps(year, month) {
  const reportYear = Number(year);
  const reportMonth = Number(month);
  const startDate = new Date(reportYear, reportMonth - 1, 1);
  const lastReportDay = getReportLastDay(reportYear, reportMonth - 1);
  const endDate =
    lastReportDay > 0
      ? new Date(reportYear, reportMonth - 1, lastReportDay)
      : new Date(reportYear, reportMonth - 1, 0);

  return {
    startTimestamp: Math.floor(startDate.getTime() / 1000),
    endTimestamp: Math.floor(endDate.getTime() / 1000),
  };
}

export function formatReportDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function getCurrentReportMonthDateRange() {
  const today = new Date();
  const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastReportDay = getReportLastDay(today.getFullYear(), today.getMonth());
  const endDate =
    lastReportDay > 0
      ? new Date(today.getFullYear(), today.getMonth(), lastReportDay)
      : new Date(today.getFullYear(), today.getMonth(), 0);

  return {
    startDate: formatReportDate(startDate),
    endDate: formatReportDate(endDate),
  };
}

export function clampCurrentMonthDateRange(dateRange) {
  if (!dateRange?.startDate || !dateRange?.endDate) return dateRange;

  const selectedEndDate = parseReportDate(dateRange.endDate);
  const today = new Date();
  const currentReportMonthDateRange = getCurrentReportMonthDateRange();
  const lastAllowedDate = parseReportDate(currentReportMonthDateRange.endDate);

  if (
    selectedEndDate.getFullYear() === today.getFullYear() &&
    selectedEndDate.getMonth() === today.getMonth() &&
    selectedEndDate > lastAllowedDate
  ) {
    return {
      ...dateRange,
      endDate: currentReportMonthDateRange.endDate,
    };
  }

  return dateRange;
}

function parseReportDate(value) {
  if (value instanceof Date) return value;

  const [year, month, day] = String(value).split("-").map(Number);
  return new Date(year, month - 1, day);
}
